import { render, staticRenderFns } from "./Footer.vue?vue&type=template&id=4d10c262&"
import script from "./Footer.vue?vue&type=script&lang=js&"
export * from "./Footer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\ageo\\Documents\\Work\\fhapplication\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4d10c262')) {
      api.createRecord('4d10c262', component.options)
    } else {
      api.reload('4d10c262', component.options)
    }
    module.hot.accept("./Footer.vue?vue&type=template&id=4d10c262&", function () {
      api.rerender('4d10c262', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/core/components/Footer.vue"
export default component.exports